import { getResourcePermissionsByRole } from '../../../permission/utils/getResourcePermissionsByRole.js';
import { renderResourceIcon } from '../../../resource-detail/components/ResourceIcon/renderResourceIcon.js';
import { PermissionRole } from '@fabric/woody-client';

const folderToLocationSelectorNodeData = (folder) => {
  return {
    id: folder.id,
    title: folder.name || "Untitled",
    displayType: "folder",
    isReadOnly: folder.isReadonly,
    canCreateChildren: getResourcePermissionsByRole(folder.permission).childResources.create.allowed,
    icon: renderResourceIcon(folder, {
      size: 24
    })
  };
};
const rootToLocationSelectorNodeData = (root) => {
  return {
    id: root.id,
    title: root.folder.name || "Untitled",
    displayType: root.subtype === "inbox" ? "inbox" : "space",
    isReadOnly: root.folder.isReadonly,
    canCreateChildren: getResourcePermissionsByRole({
      role: root.folder.permissions?.role || PermissionRole.VIEWER,
      inherited: false
    }).childResources.create.allowed,
    icon: renderResourceIcon({
      ...root.folder,
      // @ts-expect-error num vs string literal
      root
    }, {
      size: 24
    })
  };
};
const ancestorToLocationSelectorNodePathItem = (ancestor) => {
  return {
    id: ancestor.id,
    title: ancestor.name
  };
};

export { ancestorToLocationSelectorNodePathItem, folderToLocationSelectorNodeData, rootToLocationSelectorNodeData };
//# sourceMappingURL=utils.js.map
